import type { FaireProductEntity } from "../../entity_types/product";

export const p_5jht7ymtu5: FaireProductEntity = {
  token: "p_5jht7ymtu5",
  type: "product",
  name: "Habanero Chili Oil",
  brandToken: "b_764s5p6h4a",
  brandName: "Chili Beak",
  imageUrl:
    "https://cdn.faire.com/fastly/7be89961f4b27f440dc7b1d12d83735e3e6d8b5fe9ac0294e797782ff40fec58.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/209b70a9822edaf652ac3774cb4d31ff75e3686ba309511fd117b89b9cefddba.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "SPICY AND FLAVORFUL - We use the highest quality chili peppers to create a moderate, slow building heat. This is a flavorful spicy chili oil that uses chile de arbol as a base and has bold roasted pepper flavor with smooth smoky notes.\n\nGLUTEN FREE, VEGAN ,100% ALL NATURAL -  We achieve our flavor perfection through simplicity; our chili oil contains only all natural ingredients. That means that there are no additives, no preservatives, no artificial colors or flavors. Our chili oils are crafted with only 100% All Natural Ingredients. \n\nUSE ON EVERYTHING - Amazing on your favorite foods like eggs, pasta, avocado toast, tacos, quesadillas, stir fry or mixed with mayo. This  has a perfect balance of heat and flavor to compliment any dish.\n\nHabanero chiles are used to kick up the spice on our original Spicy Roasted version. This blend has a bright flavor with hints of citrus and fruity notes. The burn of the Habanero really builds slow and lingers for minutes.\n",
  tags: [],
  msrpDollars: 9,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:10.982Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
